import { styled } from '@mui/material';

export const Title = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '130%',
  color: theme.palette.grey[900],
}));
